<div class="container d-flex flex-column align-items-center" *ngIf="!loading">
    <img src="assets/images/logo.png" alt="">
    <!-- <ng-container *ngIf="loading">
        <p-progressSpinner></p-progressSpinner>
      </ng-container> -->
    <button type="button" class="btn btn-primary mt-3" (click)="loggaIn()">Logga in</button>
</div>
